import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { red, grey } from '@mui/material/colors';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Button, Container, Dialog, Typography, Grid, CircularProgress } from '@mui/material';
import { notification } from '../../../utils/Notifications';
import useLogout from '../../../hooks/auth/authHook.js';
import { assignGuidesLocation } from '../../../api/guidesApi.js';

GuidesMapDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function GuidesMapDialog({ onClose, open, guide, fetchGuides, fetchUnassingnedGuides }) {
  const [logout] = useLogout();

  const initialPosition = guide.latitude && guide.longitude ? { lat: guide.latitude, lng: guide.longitude } : null;
  const [position, setPosition] = useState(initialPosition);
  const [isLoading, setIsLoading] = useState(false);

  const customMarker = new L.Icon({
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    shadowSize: [41, 41],
  });

  const LocationMarker = ({ position, setPosition }) => {
    const map = useMapEvents({
      click(e) {
        setPosition(e.latlng);
        map.flyTo(e.latlng, map.getZoom());
      },
    });

    return position === null ? null : (
      <Marker position={position} icon={customMarker}>
        <Popup>Ubicación seleccionada</Popup>
      </Marker>
    );
  };

  const handleAssingLocationClick = () => {
    if(isLoading) { return; }
    setIsLoading(true);
    updateLocation();
  }

  const buttonStyles = {
    width: '120px',
    borderRadius: '0.5rem',
    height: '38px',
  };
  
  const activeButtonStyles = {
    ...buttonStyles,
    backgroundColor: red['A400'],
    color: 'white',
    '&:hover': {
      backgroundColor: red['A700'],
    },
  };

  const inactiveButtonStyles = {
    ...buttonStyles,
    backgroundColor: grey[500],
    color: grey[300],
  };

  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  const updateLocation = () => {

    if(position === null) { return; }

    assignGuidesLocation(guide.id_recipient, position.lat, position.lng)
      .then((response) => {
        if (response.data.status_Code === 200) {
          notification({ text: "Dirección cambiada", type: "success" });
          fetchGuides();
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al obtener las guías",
            type: "error",
          });
        }
      })
      .catch(() => {
        notification({text: 'Error de conexión, revisa tu conexión a internet', type: 'error'});
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{
        style: { borderRadius: '16px', width: '100%', height: '90%' },
        sx: { maxWidth: { xs: '100%', sm: '90%', md: '90%' }, height: { xs: '90%', sm: '80%', md: '80%' } }
      }}
    >
      <Container sx={{ padding: { xs: 2, sm: 3, md: 4 } }}>
        <Typography component="div" variant="h5" sx={{ textAlign: 'center', fontWeight: 'bold', color: grey[800], marginBottom: 2 }}>
          Asignar dirección
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MapContainer center={[19.989611, -102.284604]} zoom={5} style={{ height: "60vh", width: "100%" }}>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              />
              <LocationMarker position={position} setPosition={setPosition} />
            </MapContainer>
          </Grid>
        </Grid>

        <Grid container spacing={2} justifyContent="flex-end" sx={{ marginTop: 2 }}>
          <Grid item>
            <Button
              variant="standard"
              color="primary"
              onClick={() => handleDialogClose()}
              style={{ width: '120px', borderRadius: '0.5rem', height: '38px', color: red['A400'], backgroundColor: red['50'] }}
            >
              Cancelar
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              disabled={!position}
              onClick={() => handleAssingLocationClick()}
              sx={position ? activeButtonStyles : inactiveButtonStyles}
            >
              {isLoading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Asignar'}
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
    
  );
}